import AccountingSellListingResolver from 'api/routing/listings/AccountingSellListingRoutingResolver'
import AccountingPurchaseListingResolver from 'api/routing/listings/AccountingPurchaseListingRoutingResolver'
import AccountingBankListingRoutingResolver from 'api/routing/listings/AccountingBankListingRoutingResolver'
import AccountingCashTillListingRoutingResolver from 'api/routing/listings/AccountingCashTillListingRoutingResolver'
import AccountingMiscListingRoutingResolver from 'api/routing/listings/AccountingMiscListingRoutingResolver'
import Listing from "vcomponents/listing/Listing.vue";
import ListingVatAccountCode from "vcomponents/accounting/ListingVatAccountCode.vue";

export default [
    {
        path: '/accounting-codes/search',
        name: 'accounting.code.search'
    },
    {
        path: '/taxes',
        name: 'accounting.taxes.all'
    },
    {
        path: '/taxes/search',
        name: 'accounting.taxes.search'
    },
    {
        path: '/rest/accounting/preferences/defaultPurchaseCode',
        name: 'legacy.accounting.default.code.purchase'
    },
    {
        path: '/accounting-prefs/autoaccounting/:id',
        name: 'legacy.accounting.automatic.recording'
    },
    {
        path: '/accounting/sell',
        name: 'accounting-sell',
        component: Listing,
        meta: {
            title: window.i18n.__("Journal des ventes"),
            menuId: 'accounting'
        },
        beforeEnter: (to, from, next) => {
            let listingResolver = new AccountingSellListingResolver()
            listingResolver.feed(to)
            next()
        },
        props: true
    },
    {
        path: '/accounting/purchase',
        name: 'accounting-purchase',
        component: Listing,
        meta: {
            title: window.i18n.__("Journal des achats"),
            menuId: 'accounting'
        },
        beforeEnter: (to, from, next) => {
            let listingResolver = new AccountingPurchaseListingResolver()
            listingResolver.feed(to)
            next()
        },
        props: true
    },
    {
        path: '/accounting/bank',
        name: 'accounting-bank',
        component: Listing,
        meta: {
            title: window.i18n.__("Journal de trésorerie"),
            menuId: 'accounting'
        },
        beforeEnter: (to, from, next) => {
            let listingResolver = new AccountingBankListingRoutingResolver()
            listingResolver.feed(to)
            next()
        },
        props: true
    },
    {
        path: '/accounting/cashtill',
        name: 'accounting-cashtill',
        component: Listing,
        meta: {
            title: window.i18n.__("Journal de caisse"),
            menuId: 'accounting'
        },
        beforeEnter: (to, from, next) => {
            let listingResolver = new AccountingCashTillListingRoutingResolver()
            listingResolver.feed(to)
            next()
        },
        props: true
    },
    {
        path: '/accounting/misc',
        name: 'accounting-misc',
        component: Listing,
        meta: {
            title: window.i18n.__("Journal des opérations diverses"),
            menuId: 'accounting'
        },
        beforeEnter: (to, from, next) => {
            let listingResolver = new AccountingMiscListingRoutingResolver();
            listingResolver.feed(to)
            next()
        },
        props: true
    },
    {
        path: '/accounting/listCodeVat',
        name: 'accounting.listVatCode',
        component: ListingVatAccountCode
    }
]